export default class ServiceService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntity(id, params) {
		return this.apiService.callGet('services/' + id, params)
	}

	getEntities(params) {
		return this.apiService.callGet('services', params)
	}

	createEntity(params) {
		return this.apiService.callPost('services', params)
	}

	updateEntity(id, params) {
		return this.apiService.callPut('services/' + id, params)
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('services/' + id, params)
	}

	getEntitiesForSelectBox(operatorId, params) {
		return this.apiService.callGet(''+operatorId+'/services/simple', params)
	}

	// SEARCH
	searchServicesByNameOrId(params) {
		return this.apiService.callGet('services_search', params)
	}

  // REPLACE CHANNEL
  replaceChannels(id, params) {
    return this.apiService.callPut('me/services/' + id + '/replace', params)
  }
}



// WEBPACK FOOTER //
// ./src/service/ServiceService.js